"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var helios_styles_1 = require("@carvana/helios-styles");
var styled_components_1 = require("styled-components");
/**
 * breakpoint usage:
 *
 * import {breakpoint} @carvana/helios-layout;
 * import styled from 'styled-components';
 *
 * const Container = styled.div`
 *    ${breakpoint.sm`
 *      max-width: 300px;
 *    `}
 * `;
 */
var breakpoints = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl' // 'desktopLg'
];
var breakpoint = Object.entries(helios_styles_1.breakpoint).reduce(function (accu, _a) {
    var key = _a[0], value = _a[1];
    if (!breakpoints.includes(key)) {
        return accu;
    }
    accu[key] = function (strings) {
        var interpolations = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            interpolations[_i - 1] = arguments[_i];
        }
        return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media print, (min-width: ", ") {\n      ", ";\n    }\n  "], ["\n    @media print, (min-width: ", ") {\n      ", ";\n    }\n  "])), value, styled_components_1.css.apply(void 0, __spreadArray([strings], interpolations, false)));
    };
    return accu;
}, {});
exports.default = breakpoint;
var templateObject_1;
